/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

import RoleList from './RoleList'
import RoleProfile from './RoleProfile'

import Spinner from 'components/Spinner.js';


export default class RoleContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSpinner: true,
      content: null,
      id: null,
      data: []
    };
  }

  componentDidMount() {
    this.reset();
  }

  setId = (id) => {
    this.setState({
      content: <RoleProfile role_id={id} reset={this.reset} />,
      showSpinner: false,
    });
  }

  reset = () => {
    this.setState({ 
      content: <RoleList setId={this.setId} />,
      showSpinner: false,
    });
  }

  render ()
  {
    return (
      <Fragment>
        <a href='#' onClick={this.reset}>Role List</a>
        <div>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.content }
        </div>
      </Fragment>
    );
  }
}
